import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import {
  deleteEmailAttachment, getEmailAttachments, updateEmailAttachment, uploadEmailAttachment,
} from '../../../api/EmailTemplate/emailAttachments';
import { EmailDocKind, EmailDocumentList } from '../../../utility/listingEmail';

const KEY = [ 'emailAttachments' ];

export function useEmailAttachments() {
  const query = useQuery({ queryKey: KEY, queryFn: () => getEmailAttachments(), retry: false });
  const data = query.data?.data as (EmailDocumentList & { success: boolean }) | undefined;
  return {
    documents: data?.results ?? [],
    maxAdditional: data?.max_additional ?? 10,
    maxMb: data?.max_mb ?? 10,
    isLoading: query.isLoading,
    error: query.error,
  };
}

export function useEmailAttachmentActions() {
  const queryClient = useQueryClient();
  const onSuccess = () => queryClient.invalidateQueries({ queryKey: KEY });
  return {
    upload: useMutation({
      mutationFn: (input: { file: File; kind: EmailDocKind; name?: string }) => uploadEmailAttachment(input),
      onSuccess,
    }),
    update: useMutation({
      mutationFn: ({ id, ...values }: { id: string; name?: string; attach_by_default?: boolean }) => updateEmailAttachment(id, values),
      onSuccess,
    }),
    remove: useMutation({ mutationFn: (id: string) => deleteEmailAttachment(id), onSuccess }),
  };
}
